import { Flex, FlexProps, Text } from "@chakra-ui/react";
import React from "react";
import * as FSR from "src/generated/hooks/form-service/requests";
import { PaidTag } from "./PaidTag";

type Props = { payment: FSR.PaymentForMe; paid?: boolean } & FlexProps;
export const PaymentInfo: React.FC<Props> = ({
  payment,
  paid = false,
  ...flexProps
}) => {
  return (
    <Flex direction="column" grow="1" {...flexProps}>
      <Flex gap="2">
        <Text fontWeight="semibold">{payment.name}</Text>
        {paid ? <PaidTag /> : null}
      </Flex>
      <Text>{payment.description}</Text>
      {payment.form
        ? `${payment.form.enrollmentPeriodName} · ${
            payment.form.formTemplateName
          }${payment.form.gradeName ? " · " + payment.form.gradeName : ""}`
        : null}
      <Text>{payment.person.fullName}</Text>
    </Flex>
  );
};
